'use client';

import React from 'react';
import { CenteredContainer } from '@ianesthesie-kit/core';
import { BoxProps, CircularProgress } from '@mui/material';

export const FullPageLoader = ({ sx, ...props }: BoxProps) => (
  <CenteredContainer
    {...props}
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      ...sx
    }}
  >
    <CircularProgress />
  </CenteredContainer>
);
